import { NotifyHelper } from "../../../helpers/toast";
import { eXepHangTotNghiepActionsObj } from "../../action-types/category/IXepHangTotNghiepActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const xepHangTotNghiepActions = {
    ...generateActions(eXepHangTotNghiepActionsObj, "XEP_HANG_TOT_NGHIEP"), 
    ...generateActionForKey(eXepHangTotNghiepActionsObj, "XEP_HANG_TOT_NGHIEP", "SAVE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eXepHangTotNghiepActionsObj, "XEP_HANG_TOT_NGHIEP", "DELETE_SUCCESS", () => { NotifyHelper.Success("Thành công") }),
    ...generateActionForKey(eXepHangTotNghiepActionsObj, "XEP_HANG_TOT_NGHIEP", "SAVE_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eXepHangTotNghiepActionsObj, "XEP_HANG_TOT_NGHIEP", "DELETE_ERROR", (m) => { NotifyHelper.Error(m) }),
}